<modal
  [modalId]="'customer-form'"
  [modalSize]="'md'"
  (close)="modalCleanup()">
  <h3 class="d-inline text-capitalize" modal-title>{{this.customer == null ? 'Add Customer' : 'Edit Customer'}}</h3>
  <div class="modal-inner h-100 pt-3" modal-inner>
    <form class="d-flex flex-column" id="form" [formGroup]="form" autocomplete="off" (ngSubmit)="submitForm()">
      <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
        <mat-label>Customer Name</mat-label>
        <input required matInput formControlName="name" />
        <mat-error>Please enter a customer name</mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
        <mat-label>Customer Instance Url</mat-label>
        <input required matInput formControlName="cloudInstanceUrl" />
        <mat-error>Please enter a customer instance url</mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
        <mat-label>Subdomain</mat-label>
        <input required matInput formControlName="subdomain" />
        <mat-error>Please enter a subdomain</mat-error>
      </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
            <mat-label>Tenant Id</mat-label>
            <input required matInput formControlName="tenantId" />
            <mat-error>Please enter a Tenant Id</mat-error>
        </mat-form-field>

        <div class="labelled-slider simple-slider">
          <span>Enabled:</span>
          <label class="switch">
            <input type="checkbox" formControlName="enabled">
            <span class="slider round"></span>
          </label>
        </div>

      <mat-divider class="my-2"></mat-divider>

      <div class="modal-button-row mt-3 row px-3 justify-content-between" *ngIf="customer != null">
        <button
          mat-flat-button
          color="warn"
          id="delete"
          type="button"
          (click)="deleteCustomer()"
          [disabled]="requestInProgress">
          Delete
        </button>
        <button mat-flat-button color="accent" id="edit" type="submit" [disabled]="requestInProgress">
          Save Changes
        </button>
      </div>

      <div class="modal-button-row mt-3 row px-3 justify-content-end" *ngIf="customer == null">
        <button mat-flat-button color="accent" id="add" type="submit" [disabled]="requestInProgress">
          Add Customer
        </button>
      </div>
    </form>
  </div>
</modal>
